import store from '../store/index'

export default class StaffService {
    async getStaffs() {
        const data = await store.dispatch('jv/get', ['staffs', {params: {include: 'team'}}]);
        return Object.values(data)
    }

    async createStaff(payload) {
        return await store.dispatch('jv/post', payload)
    }

    async updateStaff(payload) {
        return await store.dispatch('jv/patch', payload)
    }

    async deleteStaff(id) {
        return await store.dispatch('jv/delete', `staffs/${id}`)
    }

    async getStaffRelationships(id, relArr, isAdmin = false) {
        const paramsObj = {
            include: `${relArr.join(',')}`,
        }

        if (!isAdmin) paramsObj['filter[documents.is-admin][eq]'] = 0 // get public cv only

        return await store.dispatch('jv/get', [`staffs/${id}`, {
            params: paramsObj
        }])
    }

    async filterStaffRelationship(id, rel, field, compare, value) {
        return await store.dispatch('jv/get', [`staffs/${id}/${rel}`, {
            params: {
                [`filter[${field}][${compare}]`]: value
            }
        }])
    }

    logError(e) {
        const error = []
        if (e.response.data.errors) {
            // Work with each error from the JSONAPI 'errors' array
            for (const err of e.response.data.errors) {
                error.push(err.detail)
            }
        }
        return error
    }
}
